import { AlertStatus } from "@flexidao/dto";

export const formatAlertStatus = (alertStatus: AlertStatus): string => {
    switch (alertStatus) {
        case AlertStatus.Created:
            return "Created";
        case AlertStatus.InProgress:
            return "In progress";
        case AlertStatus.Solved:
            return "Solved";
        case AlertStatus.Acknowledged:
            return "Acknowledged";
    }
};
